import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const draftService = {
  async load(draftId: string) {
    const { data, error } = await supabase
      .from("drafts")
      .select("*")
      .eq("id", draftId)
      .single();

    if (error) {
      toast.error("Failed to load draft");
      return null;
    }

    return data;
  },

  async save({
    draftId,
    content,
    wordCount,
    userId,
    topicId
  }: {
    draftId: string | null;
    content: string;
    wordCount: number;
    userId: string;
    topicId: string;
  }) {
    if (draftId) {
      const { error } = await supabase
        .from("drafts")
        .update({
          content,
          word_count: wordCount,
          is_submitted: true,
          updated_at: new Date().toISOString(),
        })
        .eq("id", draftId);

      if (error) throw error;
      return draftId;
    }

    const { data: newDraft, error } = await supabase
      .from("drafts")
      .insert({
        user_id: userId,
        topic_id: topicId,
        content,
        word_count: wordCount,
        is_submitted: true,
      })
      .select()
      .single();

    if (error) throw error;
    return newDraft.id;
  }
};